<template>
    <div class="modal-sm modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Пополнение баланса</h3>
          <button type="button" class="close" @click="hide()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="alert alert-success my-1" v-if="this.region">
          Вы уверены что хотите удалить тариф?
        </div>
        <div class="alert alert-danger my-1" v-if="validationError">
          {{validationError}}
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <btn-action
            class="btn btn-primary"
            @click="save"
          >Да</btn-action>
        </div>
      </div>
    </div>
  </template>
  <script>
    import api from '@/api'
    import {pick, cloneDeep} from 'lodash'
  
    export default {
      props: ['tariff'],
      data () {
        return {
          validationError: '',
          balance: 0,
        }
      },
      methods: {
        save () {
          this.balance = Number(this.regionData.count) + Number(this.region.money)
          api.post(`billing/tariffs/remove`, {tariff_id: this.tariff.id})
          .then(({data}) => {
                this.hide(false)
                window.alert(`Тариф удалён!`)
              })
          .catch(this.handleError)
        },
        hide (refresh = false) {
          this.$emit('hide', {
            refresh: refresh,
          })
        },
        handleError (error) {
          if (error.response && error.response.status === 422) {
            let obj = error.response.data.validation
            this.validationError = obj[Object.keys(obj)[0]][0]
          } else {
            throw error
          }
        },
      },
      mounted () {
        if (this.user) {
          this.regionData = pick(this.user, ['count'])
        } else {
          this.regionData = {
              count: '',
            }
        }
      },
    }
  </script>
  


// WEBPACK FOOTER //
// resources/assets/js/components/billing/modals/tariff-remove.vue